<nav backgroundColor="primary" mat-align-tabs="start" mat-tab-nav-bar [tabPanel]="tabPanel" mat-stretch-tabs="false">

   <a (click)="activeLink = '/setup/assignment/autobook/history'"
      [active]="activeLink.startsWith('/setup/assignment/autobook/history')"
      [routerLink]="'/setup/assignment/autobook/history'" mat-tab-link>History</a>

   <a (click)="activeLink = '/setup/assignment/autobook/profiles'"
      [active]="activeLink.startsWith('/setup/assignment/autobook/profiles')"
      [routerLink]="'/setup/assignment/autobook/profiles'" mat-tab-link>Profiles</a>

   <a (click)="activeLink = '/setup/assignment/autobook/visitRules'"
      [active]="activeLink.startsWith('/setup/assignment/autobook/visitRules')"
      [routerLink]="'/setup/assignment/autobook/visitRules'" mat-tab-link>Visit Rules</a>
</nav>
<mat-tab-nav-panel #tabPanel>
   <router-outlet></router-outlet>
</mat-tab-nav-panel>